import {
  Box,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import Pagination from "../../components/Panigation";
import React from "react";
import { useGetRevenueListQuery } from "../../service/features/api";
import moment from "moment";
import { SaudiRiyal } from "lucide-react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ManageRevenue = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const { data: revenueData, isLoading } = useGetRevenueListQuery({
    search: searchTerm,
    page,
    limit,
  });

  const rows = revenueData?.data?.docs || [];
  const totalRevenue = revenueData?.data?.totalRevenue ?? 0;
  const totalDocs = revenueData?.data?.totalDocs || 0;
  const totalPages = revenueData?.data?.totalPages || 1;

  const getStatusClass = (status: string) => {
    switch (status?.toUpperCase()) {
      case "ACTIVE": return "c_success";
      case "CANCELED": return "c_danger";
      case "PENDING": return "c_warning";
      default: return "c_warning";
    }
  };

  return (
    <>
      <CommonBreadcrumb
        title="Revenue Management / إدارة الإيرادات"
        breadcrumbItems={[
          { label: "Dashboard / لوحة المعلومات", onClick: () => navigate("/dashboard") },
          { label: "Revenue Management / إدارة الإيرادات" },
        ]}
      />

      {/* STATS */}
      <div className="stats_boxes v3 gap_m mb_20">
        <div className="cards w_33">
          <figure><SaudiRiyal /></figure>
          <h2 style={{ display:'flex', gap: '4px'}}><SaudiRiyal /> {totalRevenue.toLocaleString()}</h2>
          <p>Total Revenue / إجمالي الإيرادات</p>
        </div>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1">
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="revenue tabs" className="custom_tabs_links">
              <Tab label="Package Revenue / إيرادات الباقات" {...a11yProps(0)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={tabValue} index={0}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={(val) => { setSearchTerm(val); setPage(1); }}
                placeholder="Search... / ابحث..."
              />
            </div>
          </div>

          {isLoading ? (
            <div className="loading_state">Loading... / جارٍ التحميل...</div>
          ) : (
            <>
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No. / الرقم التسلسلي</TableCell>
                      <TableCell>User Detail / تفاصيل المستخدم</TableCell>
                      <TableCell>Package Name / اسم الباقة</TableCell>
                      <TableCell>Amount Received / المبلغ المستلم</TableCell>
                      <TableCell>Payment Received On / تاريخ استلام الدفع</TableCell>
                      <TableCell>Payment Status / حالة الدفع</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {rows.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center">No records found / لا توجد سجلات</TableCell>
                      </TableRow>
                    ) : (
                      rows.map((row: any, index: number) => (
                        <TableRow hover key={row._id}>
                          <TableCell>{(page - 1) * limit + index + 1}</TableCell>

                          <TableCell>
                            <div className="user_block">
                              <p>
                                <b>{row.user?.fullName || "N/A / غير متوفر"}</b>
                                {row.user?.email && <><br />{row.user.email}</>}
                                {row.user?.phone && <><br />{row.user.phone}</>}
                              </p>
                            </div>
                          </TableCell>

                          <TableCell>{row.planDetails?.name || "N/A / غير متوفر"}</TableCell>
                          <TableCell><div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><SaudiRiyal size={16}/>{(row.amountPaid ?? 0).toLocaleString()}</div></TableCell>
                          <TableCell>{row.createdAt ? moment(row.createdAt).format("DD MMMM YYYY") : "N/A / غير متوفر"}</TableCell>

                          <TableCell>
                            <span className={`status_btn dark ${getStatusClass(row.status)}`}>
                              {row.status || "N/A / غير متوفر"}
                            </span>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Pagination
                module={rows}
                page={page}
                totalPages={totalPages}
                totalCount={totalDocs}
                setPage={setPage}
                onPageChange={(p) => setPage(p)}
              />
            </>
          )}
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageRevenue;